import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { useStore } from '../../store';

const { CONTROLLERS: { EXPENSES: { VERSION, BASE } } } = USER;

const { setExpensesData } = useStore.getState();

export const useExpensesListQuery = ({ customerId }: { customerId: string }) => useQuery(
  'expenses',
  async () => {
    if (!customerId) {
      return null;
    }
    const { data } = await httpService.get((`${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}`));
    return data;
  },
  {
    onSuccess: (data) => {
      setExpensesData(data);
    },
    refetchOnWindowFocus: false,
  },
);
